import styled from '@emotion/styled';
import { COLORS } from '../../../../../constants/radar';

export const Container = styled.div`
  padding: 24px;
  height: 100%;
  overflow-y: auto;
`;

export const ResultCount = styled.div`
  color: #64748B;
  font-size: 14px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    font-weight: 600;
  }
`;

export const FormContainer = styled.div`
  flex: 1;
  background: white;
  overflow-y: auto;
  padding: 8px 24px 0 24px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const Title = styled.h2`
  color: ${COLORS.PRIMARY};
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`;

export const ActionButton = styled.button`
  padding: 8px 16px;
  background-color: white;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${COLORS.PRIMARY};
    color: white;
  }

  svg {
    font-size: 16px;
  }
`;

export const FeedbackCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  min-height: 200px;
  height: auto;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const CardTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
`;

export const CardContent = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UserName = styled.span`
  font-size: 14px;
  color: ${COLORS.SECONDARY};
  font-weight: 500;
`;

export const DateInfo = styled.span`
  font-size: 12px;
  color: ${COLORS.GRAY};
`; 